import React, { useEffect } from 'react';
import {
    Typography,
    Stack,
    IconButton,
    DialogContent,
    CircularProgress,
} from '@mui/material';
import DialogHeader from '@shared/ui/dialog/DialogHeader';
import { Close } from '@mui/icons-material';
import { Connection } from '@domain/connection/models/Connection';


interface BolCredentialsFormProps {
    onNewConnection: (connection: Connection) => void;
    onClose: () => void;
    searchParams?: string;
    /** When set, the OAuth flow re-authorizes this existing connection instead of creating a new one. */
    reconnectConnectionId?: string;
}

const BolCredentialsForm: React.FC<BolCredentialsFormProps> = ({ onNewConnection, onClose, searchParams = '', reconnectConnectionId }) => {
    const pathname = window.location.pathname;
    const baseState = searchParams ? `${pathname}?${searchParams}` : pathname;
    // The connectionId is carried through Bol's OAuth `state` so the callback can re-authorize this connection.
    const state = reconnectConnectionId
        ? `${baseState}${baseState.includes('?') ? '&' : '?'}reconnect=${reconnectConnectionId}`
        : baseState;

    const clientId = import.meta.env.VITE_BOL_CLIENT_ID;
    const callbackUrl = import.meta.env.VITE_BOL_CALLBACK_URL;

    const connectWithBol = async () => {
        const url = `https://login.bol.com/authorize?response_type=code&client_id=${clientId}&scope=offline_access&redirect_uri=${callbackUrl}&prompt=login&state=${encodeURIComponent(state)}`;
        window.location.href = url;
    };
    useEffect(() => {
        connectWithBol();
    }, []);

    return (
        <>
            <DialogHeader>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight="medium">
                        {reconnectConnectionId ? 'Reconnecting to Bol.com...' : 'Connecting to Bol.com...'}
                    </Typography>
                    <IconButton onClick={onClose} color="inherit">
                        <Close />
                    </IconButton>
                </Stack>
            </DialogHeader>

            <DialogContent>
                <CircularProgress />
            </DialogContent>
        </>
    );
};

export default BolCredentialsForm;